import type { ReactNode } from "react";
import { Link } from "wouter";
import {
  auctionGradeById,
  type AuctionCondition,
  type AuctionConditionId,
} from "@shared/auction-condition";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

type AuctionConditionDialogProps = {
  gradeId: AuctionConditionId | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children?: ReactNode;
};

export function AuctionConditionDialogPanel({
  grade,
  onClose,
}: {
  grade: AuctionCondition;
  onClose: () => void;
}) {
  return (
    <>
      <DialogHeader className="text-right sm:text-right">
        <DialogTitle>{grade.line}</DialogTitle>
      </DialogHeader>
      <ul className="list-disc space-y-2 ps-5 text-sm leading-relaxed text-muted-foreground">
        {grade.bullets.map((bullet) => (
          <li key={bullet}>{bullet}</li>
        ))}
      </ul>
      <Link
        href={"/car-condition#" + grade.id}
        className="text-sm font-semibold text-(--logo-blue) hover:underline"
      >
        {grade.readMoreLabel}
      </Link>
      <div>
        <Button type="button" variant="outline" onClick={onClose}>
          إغلاق
        </Button>
      </div>
    </>
  );
}

export function AuctionConditionDialog({
  gradeId,
  open,
  onOpenChange,
  children,
}: AuctionConditionDialogProps) {
  const grade = auctionGradeById(gradeId);
  if (!grade) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {children}
      <DialogContent dir="rtl" className="text-right sm:text-right">
        <AuctionConditionDialogPanel grade={grade} onClose={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
